import {BlockContext} from 'blocks/blocks'
import {useContext} from 'react'
import {DPAnchorBlock} from 'types/DPTypes'
import {supportedAnchorBlockTypes} from 'util/useAnchor'

export const Anchor: React.FC<DPAnchorBlock> = (data) => {
	const {id} = data
	const hide = useHideAnchorBlock(data)

	if (!id) return null
	if (hide) return null

	console.warn('Anchor block is found, but not substituted on page')

	return <div id={`${id}`.replace('#', '')} />
}

const useHideAnchorBlock = (block: DPAnchorBlock) => {
	const context = useContext(BlockContext)
	const index = context.blocks.findIndex((bl) => bl.id === block.id)
	const nextBlock = context.blocks[index + 1]

	if (index === -1) return false
	if (index === context.blocks.length - 1) return false
	if (!nextBlock) return false
	return !!supportedAnchorBlockTypes.find((type) => type === nextBlock._type)
}
